import { ReactNode } from 'react';
import styles from './DialogPageFooter.module.scss';

interface Props {
  children: ReactNode;
}

// The actions of a dialog page (e.g. Cancel and Confirm buttons), laid out in
// a row at the end, below the page's content.
export function DialogPageFooter(props: Props) {
  return <div className={styles['root']}>{props.children}</div>;
}
